import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "errMsg" }, null, -1)
const _hoisted_2 = {
  class: "row gy-5 g-xl-12",
  style: {"background":"transparent !important"}
}
const _hoisted_3 = { class: "col-xl-4" }
const _hoisted_4 = { class: "col-xl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserData = _resolveComponent("UserData")!
  const _component_OfferedCourses = _resolveComponent("OfferedCourses")!
  const _component_Sections = _resolveComponent("Sections")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_UserData, {
      onSemesterID: _ctx.setSemesterId,
      activeName: _ctx.activeName,
      showAlert: true,
      dashboardAlert: true,
      stats: true,
      tabs: _ctx.tabs,
      errMsg: _ctx.errMsg,
      errorMessage: _ctx.errorMessage
    }, null, 8, ["onSemesterID", "activeName", "tabs", "errMsg", "errorMessage"]),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_OfferedCourses, {
          Course: _ctx.Course,
          onLoadSection: _ctx.emitloadSection
        }, null, 8, ["Course", "onLoadSection"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.details && _ctx.details.length > 0)
          ? (_openBlock(), _createBlock(_component_Sections, {
              key: 0,
              SceduleId: _ctx.sceduleId,
              EnT_COURSE_PKG_DTL_ID: _ctx.enT_COURSE_PKG_DTL_ID,
              scscheduleDtlId: _ctx.scscheduleDtlId,
              edStudCourseRegId: _ctx.edStudCourseRegId,
              isReplace: _ctx.isReplace,
              CourseId: _ctx.courseId,
              Sectionetails: _ctx.details
            }, null, 8, ["SceduleId", "EnT_COURSE_PKG_DTL_ID", "scscheduleDtlId", "edStudCourseRegId", "isReplace", "CourseId", "Sectionetails"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}